export enum Launch_Is_of_tbet {
  "ES" = "ES",
  "HU" = "HU",
}
